// Contract addresses from deployment (converted to Hedera account ID format)
export const CONTRACTS = {
  testnet: {
    // Actual Hedera account IDs from testnet deployment
    ProfitableSaucerSwap: '0.0.6917343',
    SwapLottery: '0.0.6917342',
  },
  mainnet: {
    ProfitableSaucerSwap: '', // To be deployed
    SwapLottery: '', // To be deployed
  }
};

// SaucerSwap V2 contract addresses
export const SAUCERSWAP_CONTRACTS = {
  testnet: {
    swapRouter: '0x0000000000000000000000000000000000159398',
    quoterV2: '0x00000000000000000000000000000000001535b2',
    whbar: '0x0000000000000000000000000000000000003ad1',
  },
  mainnet: {
    swapRouter: '0x0000000000000000000000000000000003D4C0A',
    quoterV2: '0x0000000000000000000000000000000003C57A8',
    whbar: '0x00000000000000000000000000000000164079',
  }
};

// Current network (set based on environment)
export const CURRENT_NETWORK = 'testnet' as 'testnet' | 'mainnet';

// Get contract address for current network
export const getContractAddress = (contractName: keyof typeof CONTRACTS.testnet) => {
  return CONTRACTS[CURRENT_NETWORK][contractName];
};

// Get SaucerSwap contract address for current network
export const getSaucerSwapAddress = (contractName: keyof typeof SAUCERSWAP_CONTRACTS.testnet) => {
  return SAUCERSWAP_CONTRACTS[CURRENT_NETWORK][contractName];
};